import type { WishlistCreator } from '@fluenceur/types';

/** Email partition of a bulk selection. Email mode skips the mail-less items
 * (nothing to send to); link mode anchors them on their social profile
 * server-side, so the partition only gates the EMAIL channel's counts. */
export interface BulkEmailPartition {
  withEmail: WishlistCreator[];
  withoutEmail: WishlistCreator[];
  emailCount: number;
  totalCount: number;
}

/** Split a bulk selection by whether each creator has a resolved email. */
export const partitionByEmail = (items: WishlistCreator[]): BulkEmailPartition => {
  const withEmail = items.filter((item) => !!item.email);
  const withoutEmail = items.filter((item) => !item.email);
  return {
    withEmail,
    withoutEmail,
    emailCount: withEmail.length,
    totalCount: items.length,
  };
};
